import { api } from "@/lib/api";

// Video-ad watch analytics: sends starts, 25/50/75/100% milestones and real
// watched seconds to /ads/{id}/video-progress. Milestones are deduped per ad
// per app session; watched seconds accumulate across loops (real watch time).
const _flags = new Map();
const _f = (id) => { if (!_flags.has(id)) _flags.set(id, {}); return _flags.get(id); };

const _send = (adId, event, seconds) => {
  api.post(`/ads/${adId}/video-progress`, { event, seconds: Math.round((seconds || 0) * 10) / 10 }).catch(() => {});
};

export const attachAdVideoTracking = (video, adId) => {
  if (!video || !adId) return () => {};
  const f = _f(adId);
  let lastT = null;
  let unsent = 0;

  const flushAs = (event) => { _send(adId, event, unsent); unsent = 0; };
  const onPlay = () => {
    lastT = video.currentTime;
    if (!f.start) { f.start = true; _send(adId, "start", 0); }
  };
  const onTime = () => {
    const t = video.currentTime;
    if (lastT != null && t > lastT && t - lastT < 2) unsent += t - lastT;
    lastT = t;
    const d = video.duration;
    if (!d || !isFinite(d) || d <= 0) return;
    const p = t / d;
    if (p >= 0.25 && !f.q25) { f.q25 = true; flushAs("q25"); }
    if (p >= 0.5 && !f.q50) { f.q50 = true; flushAs("q50"); }
    if (p >= 0.75 && !f.q75) { f.q75 = true; flushAs("q75"); }
    if (p >= 0.97 && !f.q100) { f.q100 = true; flushAs("q100"); }
  };
  const onEnded = () => { if (!f.q100) { f.q100 = true; flushAs("q100"); } else if (unsent >= 1) flushAs("time"); };
  const onPause = () => { if (unsent >= 3) flushAs("time"); };

  video.addEventListener("play", onPlay);
  video.addEventListener("timeupdate", onTime);
  video.addEventListener("pause", onPause);
  video.addEventListener("ended", onEnded);
  return () => {
    video.removeEventListener("play", onPlay);
    video.removeEventListener("timeupdate", onTime);
    video.removeEventListener("pause", onPause);
    video.removeEventListener("ended", onEnded);
    if (unsent >= 1) _send(adId, "time", unsent);
  };
};
